import { render } from "./AdditionalInfo.vue?vue&type=template&id=4f247bac&scoped=true"
import script from "./AdditionalInfo.vue?vue&type=script&lang=js"
export * from "./AdditionalInfo.vue?vue&type=script&lang=js"

import "./AdditionalInfo.vue?vue&type=style&index=0&id=4f247bac&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4f247bac"

export default script